export const BOOKING_ACTION_IDS = {
  VIEW: 'view',
  EDIT: 'edit',
  DELETE: 'delete',
  CANCEL: 'cancel',
  RESTORE: 'restore',
} as const;
